<template>
  <PackDetail />
  <ActPicker style="margin-top: 36px" />
  <BoostMethod style="margin-top: 36px" />
  <DifficultPicker />
  <AddonPicker style="margin-top: 36px" />
  <OptionPicker style="margin-top: 36px" />
  <PlatformPicker style="margin-top: 36px" />
</template>

<script setup>
import PackDetail from "./pickers/PackDetail2.vue";
import DifficultPicker from "./pickers/DifficultPicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import BoostMethod from "./pickers/BoostMethod.vue";
import AddonPicker from "./pickers/AddonPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import ActPicker from "./pickers/ActPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();
const difficultyOptions = computed(() => {
  const options =
    gameStore.getGamePack?.pack_options?.filter(
      (op) => op.const_title === "hard_core" || op.const_title === "soft_core"
    ) || [];
  return options;
});

const boostMethod = computed(() => {
  const options =
    gameStore.getGamePack?.pack_options?.filter(
      (op) => op.slug === "boost_method"
    ) || [];
  return options;
});

const handleDetails = () => {
  checkoutStore.clearCheckout();

  if (difficultyOptions.value) {
    checkoutStore.setPackOptions({ options: [difficultyOptions.value[0]?.id] });
  }
  console.log(boostMethod.value);
  if (boostMethod.value) {
    checkoutStore.setPackOptions({
      options: [
        ...checkoutStore.getPackOptions,
        boostMethod.value[0]?.id,
      ],
    });
  }
  const act = gameStore.getGamePack?.prices[0];
  if (act) {
    checkoutStore.setDetails({
      acts: [
        {
          id: act.id,
          title: act.title,
        },
      ],
    });
  }
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
